var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pdf-preview", {
        ref: "pdfPreview",
        attrs: { saving: _vm.saving, formData: _vm.formData },
        on: {
          "in-preview": function($event) {
            _vm.inPreview = $event
          },
          save: _vm.save,
          "save-preview": function($event) {
            return _vm.save(true)
          }
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.inPreview,
              expression: "!inPreview"
            }
          ]
        },
        [
          _c(
            "form",
            {
              attrs: { autocomplete: "off" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("h2", [
                _vm._v("FORMULARIO SOLICITUD DE COMETIDO FUNCIONARIO")
              ]),
              _c("div", { staticClass: "row mt-10" }, [
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("label", { attrs: { for: "previousDocument" } }, [
                          _vm._v(" ¿Deseas basarte en otro documento? ")
                        ]),
                        _c(
                          "v-select",
                          {
                            attrs: {
                              options: _vm.createdDocuments,
                              name: "previousDocument",
                              label: "label",
                              "data-cy": "created-document-data",
                              clearable: true
                            },
                            on: {
                              input: function($event) {
                                return _vm.getDocumentData($event)
                              }
                            },
                            model: {
                              value: _vm.previousDocument,
                              callback: function($$v) {
                                _vm.previousDocument = $$v
                              },
                              expression: "previousDocument"
                            }
                          },
                          [
                            _c("template", { slot: "no-options" }, [
                              _vm._v(" no hay documentos registrados ")
                            ])
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "row mt-10" },
                [
                  _vm._m(0),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("validate-field", {
                        attrs: {
                          field: "requesterName",
                          label: "Usuario solicitante"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var invalid = ref.invalid
                              return [
                                _c("ListUser", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  staticClass: "w-100 mb-0",
                                  attrs: {
                                    autocomplete: "",
                                    label: "",
                                    name: "requesterName",
                                    placeholder:
                                      "Ingrese el nombre del solicitante",
                                    "data-vv-as": "solicitante",
                                    "data-cy": "requester-name",
                                    state: invalid
                                  },
                                  on: { "full-user": _vm.setRequesterData },
                                  model: {
                                    value: _vm.formData.requester,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "requester", $$v)
                                    },
                                    expression: "formData.requester"
                                  }
                                }),
                                _vm._v(
                                  " Se completa automáticamente. Verifica que tu nombre esté correcto. "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("validate-field", {
                        attrs: {
                          field: "requesterIut",
                          label: "Rut usuario solicitante"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var invalid = ref.invalid
                              return [
                                _c("b-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "requesterIut",
                                    placeholder:
                                      "Ingrese el rut del nombre del solicitante",
                                    "data-vv-as": "rut solicitante",
                                    "data-cy": "requester-iut",
                                    state: invalid
                                  },
                                  model: {
                                    value: _vm.formData.requesterIut,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "requesterIut",
                                        $$v
                                      )
                                    },
                                    expression: "formData.requesterIut"
                                  }
                                }),
                                _vm._v(
                                  " Se completa automáticamente. Revisa que el número esté correcto. "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("validate-field", {
                        attrs: {
                          field: "requestDate",
                          label: "Fecha de solicitud"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var invalid = ref.invalid
                              return [
                                _c("date-picker", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "requestDate",
                                    placeholder:
                                      "Seleccione la fecha de solicitud",
                                    "data-vv-as": "fecha de solicitud",
                                    "data-cy": "request-date",
                                    format: "YYYY-MM-DD",
                                    invalid: invalid,
                                    disablePastDates: true
                                  },
                                  on: {
                                    "formatted-input": function($event) {
                                      _vm.formData.requestDate = $event
                                    }
                                  },
                                  model: {
                                    value: _vm.formData.requestDate,
                                    callback: function($$v) {
                                      _vm.$set(_vm.formData, "requestDate", $$v)
                                    },
                                    expression: "formData.requestDate"
                                  }
                                }),
                                _vm._v(
                                  " Fecha en que ingresas la solicitud. El sistema la carga automáticamente. "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("validate-field", {
                        attrs: {
                          field: "requesterUnit",
                          label: "Unidad requirente"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var invalid = ref.invalid
                              return [
                                _c("select-options", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "requesterUnit",
                                    "alphabetical-sort": true,
                                    "options-group": "fisabs-requester-unit",
                                    "data-vv-as": "unidad requirente",
                                    "data-cy": "requester-unit",
                                    invalid: invalid
                                  },
                                  model: {
                                    value: _vm.formData.requesterUnit,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "requesterUnit",
                                        $$v
                                      )
                                    },
                                    expression: "formData.requesterUnit"
                                  }
                                }),
                                _vm._v(
                                  " Selecciona la unidad a la que perteneces según el organigrama institucional. "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("validate-field", {
                        attrs: {
                          field: "requesterPosition",
                          label: "Cargo del solicitante"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var invalid = ref.invalid
                              return [
                                _c("b-input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "requesterPosition",
                                    placeholder:
                                      "Ingrese el cargo del solicitante",
                                    "data-vv-as": "cargo del solicitante",
                                    "data-cy": "requester-position",
                                    state: invalid
                                  },
                                  model: {
                                    value: _vm.formData.requesterPosition,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "requesterPosition",
                                        $$v
                                      )
                                    },
                                    expression: "formData.requesterPosition"
                                  }
                                }),
                                _vm._v(
                                  " Ingresa tu cargo actual tal como aparece en tu designación o convenio. "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("validate-field", {
                        attrs: {
                          field: "requesterLegalStatus",
                          label: "Calidad Jurídica del solicitante"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var invalid = ref.invalid
                              return [
                                _c("select-options", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "requesterLegalStatus",
                                    "alphabetical-sort": true,
                                    "options-group": "calidad-juridica",
                                    "data-vv-as":
                                      "calidad Jurídica del solicitante",
                                    "data-cy": "requester-legal-status",
                                    invalid: invalid
                                  },
                                  on: {
                                    input: _vm.onRequesterLegalStatusChange
                                  },
                                  model: {
                                    value: _vm.formData.requesterLegalStatus,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "requesterLegalStatus",
                                        $$v
                                      )
                                    },
                                    expression: "formData.requesterLegalStatus"
                                  }
                                }),
                                _vm._v(
                                  " Selecciona tu condición contractual: Planta, Contrata u Honorarios. "
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm.shouldShowRequesterGrade
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("validate-field", {
                            attrs: {
                              field: "requesterGrade",
                              label: "Grado del solicitante"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var invalid = ref.invalid
                                    return [
                                      _c("b-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required:
                                                _vm.shouldShowRequesterGrade
                                            },
                                            expression:
                                              "{ required: shouldShowRequesterGrade }"
                                          }
                                        ],
                                        attrs: {
                                          name: "requesterGrade",
                                          placeholder:
                                            "Ingrese el grado del solicitante",
                                          "data-vv-as": "grado del solicitante",
                                          "data-cy": "requester-grade",
                                          state: invalid
                                        },
                                        model: {
                                          value: _vm.formData.requesterGrade,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "requesterGrade",
                                              $$v
                                            )
                                          },
                                          expression: "formData.requesterGrade"
                                        }
                                      }),
                                      _vm._v(
                                        " Grado actual, según el registro vigente en Gestión de Personas. "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3237147891
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._m(1),
                  _vm._m(2),
                  _c("div", { staticClass: "col-12 mb-2" }, [
                    _vm._v(
                      " Importante: las fechas que se ingresen en este campo, correspondientes al cometido, deben ajustarse a lo establecido en la normativa vigente de la Universidad. "
                    )
                  ]),
                  _vm._l(_vm.formData.periods, function(period, idx) {
                    return _c(
                      "div",
                      { key: "period-" + idx, staticClass: "col-12" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _vm.formData.periods.length > 1
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("h6", { staticClass: "text-primary" }, [
                                  _vm._v(" Periodo " + _vm._s(idx + 1) + " ")
                                ])
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "startDate_" + idx,
                                  label: "Fecha de inicio"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: period.startDate,
                                                expression: "period.startDate"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              type: "hidden",
                                              name: "startDate_" + idx,
                                              "data-vv-name":
                                                "startDate_" + idx,
                                              "data-vv-as": "fecha de inicio"
                                            },
                                            domProps: {
                                              value: period.startDate
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  period,
                                                  "startDate",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _c("date-picker", {
                                            attrs: {
                                              name: "startDate_" + idx,
                                              "data-vv-name":
                                                "startDate_" + idx,
                                              placeholder:
                                                "Seleccione la fecha de inicio",
                                              "data-vv-as": "fecha de inicio",
                                              "data-cy": "start-date-" + idx,
                                              type: "datetime",
                                              format: "YYYY-MM-DD HH:mm",
                                              "value-type": "YYYY-MM-DD HH:mm",
                                              invalid: invalid,
                                              disablePastDates: true
                                            },
                                            on: {
                                              "formatted-input": function(
                                                $event
                                              ) {
                                                return _vm.onPeriodStartDateInput(
                                                  $event,
                                                  idx
                                                )
                                              }
                                            },
                                            model: {
                                              value: period.startDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  period,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression: "period.startDate"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "endDate_" + idx,
                                  label: "Fecha de término"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("date-picker", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "endDate_" + idx,
                                              "data-vv-name": "endDate_" + idx,
                                              placeholder:
                                                "Seleccione la fecha de término",
                                              "data-vv-as": "fecha de término",
                                              "data-cy": "end-date-" + idx,
                                              type: "datetime",
                                              format: "YYYY-MM-DD HH:mm",
                                              invalid: invalid,
                                              disablePastDates: true
                                            },
                                            on: {
                                              "formatted-input": function(
                                                $event
                                              ) {
                                                period.endDate = $event
                                              }
                                            },
                                            model: {
                                              value: period.endDate,
                                              callback: function($$v) {
                                                _vm.$set(period, "endDate", $$v)
                                              },
                                              expression: "period.endDate"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex justify-content-end gap-2 mt-2"
                            },
                            [
                              idx > 0
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-danger",
                                        "data-cy": "period-remove-" + idx
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removePeriodItem(idx)
                                        }
                                      }
                                    },
                                    [_vm._v(" Quitar periodo ")]
                                  )
                                : _vm._e(),
                              idx === _vm.formData.periods.length - 1
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-primary",
                                        "data-cy": "period-add"
                                      },
                                      on: { click: _vm.addPeriodItem }
                                    },
                                    [_vm._v(" + Agregar periodo ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          idx < _vm.formData.periods.length - 1
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("hr", { staticClass: "my-6" })
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  _vm._m(3),
                  _vm._l(_vm.formData.destinations, function(destination, idx) {
                    return _c(
                      "div",
                      { key: "destination-" + idx, staticClass: "col-12" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _vm.formData.destinations.length > 1
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("h6", { staticClass: "text-primary" }, [
                                  _vm._v(" Destino " + _vm._s(idx + 1) + " ")
                                ])
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "countryOfMission_" + idx,
                                  label: "País de destino"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  destination.countryOfMission,
                                                expression:
                                                  "destination.countryOfMission"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              type: "hidden",
                                              name: "countryOfMission_" + idx,
                                              "data-vv-name":
                                                "countryOfMission_" + idx,
                                              "data-vv-as": "país de destino"
                                            },
                                            domProps: {
                                              value:
                                                destination.countryOfMission
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  destination,
                                                  "countryOfMission",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _c(
                                            "v-select",
                                            {
                                              class: {
                                                "v-select-danger": _vm.$validator.errors.has(
                                                  "countryOfMission_" + idx
                                                )
                                              },
                                              attrs: {
                                                name: "countryOfMission_" + idx,
                                                "alphabetical-sort": true,
                                                "data-vv-as": "país de destino",
                                                "data-cy":
                                                  "country-of-mission-" + idx,
                                                invalid: invalid,
                                                placeholder: "Seleccione",
                                                state: _vm.$validator.errors.has(
                                                  "countryOfMission_" + idx
                                                )
                                                  ? false
                                                  : null,
                                                danger: _vm.$validator.errors.has(
                                                  "countryOfMission_" + idx
                                                ),
                                                "danger-text": _vm.$validator.errors.first(
                                                  "countryOfMission_" + idx
                                                ),
                                                selectable: function(opt) {
                                                  return !opt.disabled
                                                },
                                                options: _vm.countries,
                                                clearable: true
                                              },
                                              on: {
                                                input: function($event) {
                                                  _vm.onDestinationCountryInput(
                                                    $event,
                                                    idx
                                                  )
                                                  _vm.searchCitiesForDestination(
                                                    $event,
                                                    idx
                                                  )
                                                }
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "spinner",
                                                    fn: function() {
                                                      return [
                                                        _vm.loadingCountries
                                                          ? _c("b-spinner", {
                                                              style: {
                                                                opacity: _vm.loadingCountries
                                                                  ? 1
                                                                  : 0
                                                              },
                                                              attrs: {
                                                                small: "",
                                                                variant:
                                                                  "primary"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value:
                                                  destination.countryOfMission,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    destination,
                                                    "countryOfMission",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "destination.countryOfMission"
                                              }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "no-options" },
                                                [
                                                  !_vm.loadingCountries &&
                                                  !_vm.countries.length
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " no hay opciones disponibles "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(
                                            " Selecciona el país donde realizarás el cometido. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "cityOfMission_" + idx,
                                  label: "Ciudad de destino"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c(
                                            "v-select",
                                            {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              class: {
                                                "v-select-danger": _vm.$validator.errors.has(
                                                  "cityOfMission_" + idx
                                                )
                                              },
                                              attrs: {
                                                name: "cityOfMission_" + idx,
                                                "alphabetical-sort": true,
                                                "data-vv-as":
                                                  "ciudad de destino",
                                                "data-cy":
                                                  "city-of-mission-" + idx,
                                                invalid: invalid,
                                                placeholder: "Seleccione",
                                                state: _vm.$validator.errors.has(
                                                  "cityOfMission_" + idx
                                                )
                                                  ? false
                                                  : null,
                                                danger: _vm.$validator.errors.has(
                                                  "cityOfMission_" + idx
                                                ),
                                                "danger-text": _vm.$validator.errors.first(
                                                  "cityOfMission_" + idx
                                                ),
                                                selectable: function(opt) {
                                                  return !opt.disabled
                                                },
                                                options:
                                                  _vm.citiesByDestination[
                                                    idx
                                                  ] || [],
                                                clearable: true
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.setSelectedCityForDestination(
                                                    $event,
                                                    idx
                                                  )
                                                }
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "spinner",
                                                    fn: function() {
                                                      return [
                                                        _vm
                                                          .loadingCitiesByDestination[
                                                          idx
                                                        ]
                                                          ? _c("b-spinner", {
                                                              style: {
                                                                opacity: _vm
                                                                  .loadingCitiesByDestination[
                                                                  idx
                                                                ]
                                                                  ? 1
                                                                  : 0
                                                              },
                                                              attrs: {
                                                                small: "",
                                                                variant:
                                                                  "primary"
                                                              }
                                                            })
                                                          : _vm._e()
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                true
                                              ),
                                              model: {
                                                value:
                                                  destination.cityOfMission,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    destination,
                                                    "cityOfMission",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "destination.cityOfMission"
                                              }
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "no-options" },
                                                [
                                                  !_vm
                                                    .loadingCitiesByDestination[
                                                    idx
                                                  ] &&
                                                  !(
                                                    _vm.citiesByDestination[
                                                      idx
                                                    ] &&
                                                    _vm.citiesByDestination[idx]
                                                      .length
                                                  )
                                                    ? _c("span", [
                                                        _vm._v(
                                                          " no hay opciones disponibles "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]
                                              )
                                            ],
                                            2
                                          ),
                                          _vm._v(
                                            " Elige la ciudad a la que viajarás durante el cometido. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex justify-content-end gap-2 mt-2"
                            },
                            [
                              idx > 0
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-danger",
                                        "data-cy": "destination-remove-" + idx
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeDestinationItem(idx)
                                        }
                                      }
                                    },
                                    [_vm._v(" Quitar destino ")]
                                  )
                                : _vm._e(),
                              idx === _vm.formData.destinations.length - 1
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-primary",
                                        "data-cy": "destination-add"
                                      },
                                      on: { click: _vm.addDestinationItem }
                                    },
                                    [_vm._v(" + Agregar destino ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          idx < _vm.formData.destinations.length - 1
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("hr", { staticClass: "my-6" })
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  _vm._m(4),
                  _c("div", { staticClass: "col-12 mb-2" }, [
                    _vm._v(
                      " Importante: las fechas que se ingresen en este campo, correspondientes al inicio y término de la actividad deben estar debidamente respaldadas por medios de verificación válidos, de acuerdo con los criterios establecidos en la normativa universitaria. "
                    )
                  ]),
                  _vm._l(_vm.formData.activities, function(activity, idx) {
                    return _c(
                      "div",
                      { key: "activity-" + idx, staticClass: "col-12" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _vm.formData.activities.length > 1
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("h6", { staticClass: "text-primary" }, [
                                  _vm._v(" Actividad " + _vm._s(idx + 1) + " ")
                                ])
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "activityStarDate_" + idx,
                                  label: "Fecha de inicio actividad"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: activity.startDate,
                                                expression: "activity.startDate"
                                              },
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              type: "hidden",
                                              name: "activityStarDate_" + idx,
                                              "data-vv-name":
                                                "activityStarDate_" + idx,
                                              "data-vv-as":
                                                "fecha de inicio de actividad"
                                            },
                                            domProps: {
                                              value: activity.startDate
                                            },
                                            on: {
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  activity,
                                                  "startDate",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          }),
                                          _c("date-picker", {
                                            attrs: {
                                              name: "activityStarDate_" + idx,
                                              placeholder:
                                                "Seleccione la fecha de inicio de actividad",
                                              "data-vv-as":
                                                "fecha de inicio de actividad",
                                              "data-cy":
                                                "activity-start-date-" + idx,
                                              type: "datetime",
                                              format: "YYYY-MM-DD HH:mm",
                                              invalid: invalid,
                                              disablePastDates: true
                                            },
                                            on: {
                                              "formatted-input": function(
                                                $event
                                              ) {
                                                return _vm.onActivityStartDateInput(
                                                  $event,
                                                  idx
                                                )
                                              }
                                            },
                                            model: {
                                              value: activity.startDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  activity,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression: "activity.startDate"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "activityEndDate_" + idx,
                                  label: "Fecha de término actividad"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("date-picker", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "activityEndDate_" + idx,
                                              placeholder:
                                                "Seleccione la fecha de término de actividad",
                                              "data-vv-as":
                                                "fecha de término de actividad",
                                              "data-cy":
                                                "activity-end-date-" + idx,
                                              type: "datetime",
                                              format: "YYYY-MM-DD HH:mm",
                                              invalid: invalid,
                                              disablePastDates: true
                                            },
                                            on: {
                                              "formatted-input": function(
                                                $event
                                              ) {
                                                activity.endDate = $event
                                              }
                                            },
                                            model: {
                                              value: activity.endDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  activity,
                                                  "endDate",
                                                  $$v
                                                )
                                              },
                                              expression: "activity.endDate"
                                            }
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "activityName_" + idx,
                                  label: "Nombre de actividad"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name: "activityName_" + idx,
                                              placeholder:
                                                "Ingrese el nombre de actividad",
                                              "data-vv-as":
                                                "nombre de actividad",
                                              "data-cy": "activity-name-" + idx,
                                              state: invalid
                                            },
                                            model: {
                                              value: activity.name,
                                              callback: function($$v) {
                                                _vm.$set(activity, "name", $$v)
                                              },
                                              expression: "activity.name"
                                            }
                                          }),
                                          _vm._v(
                                            " Indica el nombre oficial de la actividad. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field: "activityDetail_" + idx,
                                  label: "Detalle de actividad"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-form-textarea", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              maxlength: 2000,
                                              rows: "3",
                                              "max-rows": "8",
                                              name: "activityDetail_" + idx,
                                              placeholder:
                                                "Ingrese el detalle de actividad",
                                              "data-vv-as":
                                                "detalle de actividad",
                                              "data-cy":
                                                "activity-detail-" + idx,
                                              state: invalid
                                            },
                                            model: {
                                              value: activity.detail,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  activity,
                                                  "detail",
                                                  $$v
                                                )
                                              },
                                              expression: "activity.detail"
                                            }
                                          }),
                                          _c(
                                            "small",
                                            {
                                              staticClass:
                                                "form-text text-muted text-right"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    activity.detail
                                                      ? activity.detail.length
                                                      : 0
                                                  ) +
                                                  " / 2000 "
                                              )
                                            ]
                                          ),
                                          _vm._v(
                                            " Describe claramente qué actividad realizarás y su relación con tus funciones. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex justify-content-end gap-2 mt-2"
                            },
                            [
                              idx > 0
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-danger",
                                        "data-cy": "activity-remove-" + idx
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeActivityItem(idx)
                                        }
                                      }
                                    },
                                    [_vm._v(" Quitar actividad ")]
                                  )
                                : _vm._e(),
                              idx === _vm.formData.activities.length - 1
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-primary",
                                        "data-cy": "activity-add"
                                      },
                                      on: { click: _vm.addActivityItem }
                                    },
                                    [_vm._v(" + Agregar actividad ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          idx < _vm.formData.activities.length - 1
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("hr", { staticClass: "my-6" })
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  _vm._m(5),
                  _vm._m(6),
                  _vm._l(_vm.formData.outboundSegments, function(
                    segment,
                    index
                  ) {
                    return _c(
                      "div",
                      {
                        key: "outbound-segment-" + index,
                        staticClass: "col-12"
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _vm.formData.outboundSegments.length > 1
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("h6", { staticClass: "text-primary mb-2" }, [
                                  _vm._v(
                                    " Tramo de ida " + _vm._s(index + 1) + " "
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field:
                                    "outboundSegments[" +
                                    index +
                                    "].transferNumber",
                                  label: "N° de Tramo"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "outboundSegments[" +
                                                index +
                                                "].transferNumber",
                                              placeholder:
                                                "Ingrese el n° de Tramo",
                                              "data-vv-as": "n° de Tramo",
                                              "data-cy":
                                                "outbound-transfer-number-" +
                                                index,
                                              state: invalid
                                            },
                                            model: {
                                              value: segment.transferNumber,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  segment,
                                                  "transferNumber",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "segment.transferNumber"
                                            }
                                          }),
                                          _vm._v(
                                            " Indica el número de este tramo del viaje (por ejemplo: “Tramo 1”, “Tramo 2”). "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field:
                                    "outboundSegments[" +
                                    index +
                                    "].transferType",
                                  label: "Medio de transporte"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "outboundSegments[" +
                                                index +
                                                "].transferType",
                                              "alphabetical-sort": true,
                                              "options-group":
                                                "medio-transporte",
                                              "data-vv-as":
                                                "medio de transporte",
                                              "data-cy":
                                                "outbound-transfer-type-" +
                                                index,
                                              invalid: invalid
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.onOutboundSegmentTransferTypeChange(
                                                  $event,
                                                  index
                                                )
                                              }
                                            },
                                            model: {
                                              value: segment.transferType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  segment,
                                                  "transferType",
                                                  $$v
                                                )
                                              },
                                              expression: "segment.transferType"
                                            }
                                          }),
                                          _vm._v(
                                            " Selecciona el medio de transporte utilizado en este tramo específico del viaje. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _vm.isTransferTypeOther(segment.transferType)
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field:
                                        "outboundSegments[" +
                                        index +
                                        "].transferOtherDetail",
                                      label: "Especificar medio de transporte"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-form-textarea", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: _vm.isTransferTypeOther(
                                                        segment.transferType
                                                      )
                                                    },
                                                    expression:
                                                      "{ required: isTransferTypeOther(segment.transferType) }"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "outboundSegments[" +
                                                    index +
                                                    "].transferOtherDetail",
                                                  placeholder:
                                                    "Especifique el medio de transporte",
                                                  "data-vv-as":
                                                    "especificar medio de transporte",
                                                  "data-cy":
                                                    "outbound-transfer-other-" +
                                                    index,
                                                  maxlength: 200,
                                                  rows: "3",
                                                  "max-rows": "6",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    segment.transferOtherDetail,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      segment,
                                                      "transferOtherDetail",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "segment.transferOtherDetail"
                                                }
                                              }),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "form-text text-muted text-right"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        segment.transferOtherDetail
                                                          ? segment
                                                              .transferOtherDetail
                                                              .length
                                                          : 0
                                                      ) +
                                                      " / 200 "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.shouldShowSegmentPlate(segment.transferType)
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field:
                                        "outboundSegments[" +
                                        index +
                                        "].transferPlate",
                                      label: "Patente"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: _vm.shouldShowSegmentPlate(
                                                        segment.transferType
                                                      )
                                                    },
                                                    expression:
                                                      "{ required: shouldShowSegmentPlate(segment.transferType) }"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "outboundSegments[" +
                                                    index +
                                                    "].transferPlate",
                                                  placeholder:
                                                    "Ingrese la patente",
                                                  "data-vv-as": "patente",
                                                  "data-cy":
                                                    "outbound-transfer-plate-" +
                                                    index,
                                                  maxlength: 100,
                                                  state: invalid
                                                },
                                                model: {
                                                  value: segment.transferPlate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      segment,
                                                      "transferPlate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "segment.transferPlate"
                                                }
                                              }),
                                              _vm._v(
                                                " Ingresa la patente del vehículo particular (máx. 100 caracteres). "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field:
                                    "outboundSegments[" +
                                    index +
                                    "].transferDate",
                                  label: "Fecha"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("date-picker", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "outboundSegments[" +
                                                index +
                                                "].transferDate",
                                              placeholder:
                                                "Seleccione la fecha",
                                              type: "datetime",
                                              format: "YYYY-MM-DD HH:mm",
                                              "data-vv-as": "fecha",
                                              "data-cy":
                                                "outbound-transfer-date-" +
                                                index,
                                              invalid: invalid,
                                              disablePastDates: true
                                            },
                                            on: {
                                              "formatted-input": function(
                                                $event
                                              ) {
                                                segment.transferDate = $event
                                              }
                                            },
                                            model: {
                                              value: segment.transferDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  segment,
                                                  "transferDate",
                                                  $$v
                                                )
                                              },
                                              expression: "segment.transferDate"
                                            }
                                          }),
                                          _vm._v(
                                            " Indica la fecha y hora de salida correspondiente a este tramo específico del viaje. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field:
                                    "outboundSegments[" +
                                    index +
                                    "].transferOrigin",
                                  label: "Origen"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "outboundSegments[" +
                                                index +
                                                "].transferOrigin",
                                              placeholder: "Ingrese origen",
                                              "data-vv-as": "origen",
                                              "data-cy":
                                                "outbound-transfer-origin-" +
                                                index,
                                              state: invalid
                                            },
                                            model: {
                                              value: segment.transferOrigin,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  segment,
                                                  "transferOrigin",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "segment.transferOrigin"
                                            }
                                          }),
                                          _vm._v(
                                            " Ingresa el lugar de inicio de este tramo específico del viaje. Puede ser una ciudad, aeropuerto, terminal, dirección, etc. según corresponda. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field:
                                    "outboundSegments[" +
                                    index +
                                    "].transferDestination",
                                  label: "Destino"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "outboundSegments[" +
                                                index +
                                                "].transferDestination",
                                              placeholder: "Ingrese destino",
                                              "data-vv-as": "destino",
                                              "data-cy":
                                                "outbound-transfer-destination-" +
                                                index,
                                              state: invalid
                                            },
                                            model: {
                                              value:
                                                segment.transferDestination,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  segment,
                                                  "transferDestination",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "segment.transferDestination"
                                            }
                                          }),
                                          _vm._v(
                                            " Ingresa el lugar de destino de este tramo específico del viaje. Puede ser una ciudad, aeropuerto, terminal, dirección, etc. según corresponda. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "mt-0 mt-md-8 d-inline" },
                                [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for:
                                          "outboundRefundAppliesTrue-" + index
                                      }
                                    },
                                    [_vm._v(" ¿Aplica reembolso?")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex type-resend" },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            id:
                                              "outboundRefundAppliesTrue-" +
                                              index,
                                            value: true,
                                            name:
                                              "outboundRefundApplies-" + index,
                                            "data-cy":
                                              "outbound-refund-applies-" +
                                              index,
                                            "data-vv-as": "¿Aplica reembolso?"
                                          },
                                          on: {
                                            input: function($event) {
                                              segment.justification = ""
                                            }
                                          },
                                          model: {
                                            value: segment.refundApplies,
                                            callback: function($$v) {
                                              _vm.$set(
                                                segment,
                                                "refundApplies",
                                                $$v
                                              )
                                            },
                                            expression: "segment.refundApplies"
                                          }
                                        },
                                        [_vm._v(" Si ")]
                                      ),
                                      _c(
                                        "b-form-radio",
                                        {
                                          staticClass: "ml-4",
                                          attrs: {
                                            name:
                                              "outboundRefundApplies-" + index,
                                            "data-cy":
                                              "outbound-refund-applies-" +
                                              index,
                                            "data-vv-as": "¿Aplica reembolso?",
                                            value: false
                                          },
                                          on: {
                                            input: function($event) {
                                              segment.justification = ""
                                            }
                                          },
                                          model: {
                                            value: segment.refundApplies,
                                            callback: function($$v) {
                                              _vm.$set(
                                                segment,
                                                "refundApplies",
                                                $$v
                                              )
                                            },
                                            expression: "segment.refundApplies"
                                          }
                                        },
                                        [_vm._v(" No ")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    " Indica si los gastos de este tramo específico del viaje deberán ser reembolsados "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          !segment.refundApplies
                            ? _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field:
                                        "outboundSegments[" +
                                        index +
                                        "].justification",
                                      label: "Justificación"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-form-textarea", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: !segment.refundApplies
                                                    },
                                                    expression:
                                                      "{ required: !segment.refundApplies }"
                                                  }
                                                ],
                                                attrs: {
                                                  maxlength: 2000,
                                                  rows: "3",
                                                  "max-rows": "8",
                                                  name:
                                                    "outboundSegments[" +
                                                    index +
                                                    "].justification",
                                                  "data-vv-as": "justificación",
                                                  "data-cy":
                                                    "outbound-justification-" +
                                                    index,
                                                  state: invalid,
                                                  counter: "2000",
                                                  placeholder: "Justificación"
                                                },
                                                model: {
                                                  value: segment.justification,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      segment,
                                                      "justification",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "segment.justification"
                                                }
                                              }),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "form-text text-muted text-right"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        segment.justification
                                                          ? segment
                                                              .justification
                                                              .length
                                                          : 0
                                                      ) +
                                                      " / 2000 "
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                " Si selecciona NO, debe justificar su respuesta e indicar la fuente de financiamiento. "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex justify-content-end gap-2 mt-2"
                            },
                            [
                              index > 0
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-danger",
                                        "data-cy": "outbound-remove-" + index
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeOutboundSegment(
                                            index
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(" Quitar tramo ")]
                                  )
                                : _vm._e(),
                              index === _vm.formData.outboundSegments.length - 1
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-primary",
                                        "data-cy": "outbound-add"
                                      },
                                      on: { click: _vm.addOutboundSegment }
                                    },
                                    [_vm._v(" + Agregar tramo de ida ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  }),
                  _vm._m(7),
                  _vm._l(_vm.formData.returnSegments, function(segment, index) {
                    return _c(
                      "div",
                      { key: "return-segment-" + index, staticClass: "col-12" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _vm.formData.returnSegments.length > 1
                            ? _c("div", { staticClass: "col-12" }, [
                                _c("h6", { staticClass: "text-primary mb-2" }, [
                                  _vm._v(
                                    " Tramo de regreso " +
                                      _vm._s(index + 1) +
                                      " "
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field:
                                    "returnSegments[" +
                                    index +
                                    "].transferNumber",
                                  label: "N° de Tramo"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "returnSegments[" +
                                                index +
                                                "].transferNumber",
                                              placeholder:
                                                "Ingrese el n° de Tramo",
                                              "data-vv-as": "n° de Tramo",
                                              "data-cy":
                                                "return-transfer-number-" +
                                                index,
                                              state: invalid
                                            },
                                            model: {
                                              value: segment.transferNumber,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  segment,
                                                  "transferNumber",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "segment.transferNumber"
                                            }
                                          }),
                                          _vm._v(
                                            " Indica el número de este tramo del viaje (por ejemplo: “Tramo 1”, “Tramo 2”). "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field:
                                    "returnSegments[" +
                                    index +
                                    "].transferType",
                                  label: "Medio de transporte"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("select-options", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "returnSegments[" +
                                                index +
                                                "].transferType",
                                              "alphabetical-sort": true,
                                              "options-group":
                                                "medio-transporte",
                                              "data-vv-as":
                                                "medio de transporte",
                                              "data-cy":
                                                "return-transfer-type-" + index,
                                              invalid: invalid
                                            },
                                            on: {
                                              input: function($event) {
                                                return _vm.onReturnSegmentTransferTypeChange(
                                                  $event,
                                                  index
                                                )
                                              }
                                            },
                                            model: {
                                              value: segment.transferType,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  segment,
                                                  "transferType",
                                                  $$v
                                                )
                                              },
                                              expression: "segment.transferType"
                                            }
                                          }),
                                          _vm._v(
                                            " Selecciona el medio de transporte utilizado en este tramo específico del viaje. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _vm.isTransferTypeOther(segment.transferType)
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field:
                                        "returnSegments[" +
                                        index +
                                        "].transferOtherDetail",
                                      label: "Especificar medio de transporte"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-form-textarea", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: _vm.isTransferTypeOther(
                                                        segment.transferType
                                                      )
                                                    },
                                                    expression:
                                                      "{ required: isTransferTypeOther(segment.transferType) }"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "returnSegments[" +
                                                    index +
                                                    "].transferOtherDetail",
                                                  placeholder:
                                                    "Especifique el medio de transporte",
                                                  "data-vv-as":
                                                    "especificar medio de transporte",
                                                  "data-cy":
                                                    "return-transfer-other-" +
                                                    index,
                                                  maxlength: 200,
                                                  rows: "3",
                                                  "max-rows": "6",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    segment.transferOtherDetail,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      segment,
                                                      "transferOtherDetail",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "segment.transferOtherDetail"
                                                }
                                              }),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "form-text text-muted text-right"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        segment.transferOtherDetail
                                                          ? segment
                                                              .transferOtherDetail
                                                              .length
                                                          : 0
                                                      ) +
                                                      " / 200 "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.shouldShowSegmentPlate(segment.transferType)
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field:
                                        "returnSegments[" +
                                        index +
                                        "].transferPlate",
                                      label: "Patente"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: _vm.shouldShowSegmentPlate(
                                                        segment.transferType
                                                      )
                                                    },
                                                    expression:
                                                      "{ required: shouldShowSegmentPlate(segment.transferType) }"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "returnSegments[" +
                                                    index +
                                                    "].transferPlate",
                                                  placeholder:
                                                    "Ingrese la patente",
                                                  "data-vv-as": "patente",
                                                  "data-cy":
                                                    "return-transfer-plate-" +
                                                    index,
                                                  maxlength: 100,
                                                  state: invalid
                                                },
                                                model: {
                                                  value: segment.transferPlate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      segment,
                                                      "transferPlate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "segment.transferPlate"
                                                }
                                              }),
                                              _vm._v(
                                                " Ingresa la patente del vehículo particular (máx. 100 caracteres). "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field:
                                    "returnSegments[" +
                                    index +
                                    "].transferDate",
                                  label: "Fecha"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("date-picker", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "returnSegments[" +
                                                index +
                                                "].transferDate",
                                              placeholder:
                                                "Seleccione la fecha",
                                              "data-vv-as": "fecha",
                                              type: "datetime",
                                              format: "YYYY-MM-DD HH:mm",
                                              "data-cy":
                                                "return-transfer-date-" + index,
                                              invalid: invalid,
                                              disablePastDates: true
                                            },
                                            on: {
                                              "formatted-input": function(
                                                $event
                                              ) {
                                                segment.transferDate = $event
                                              }
                                            },
                                            model: {
                                              value: segment.transferDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  segment,
                                                  "transferDate",
                                                  $$v
                                                )
                                              },
                                              expression: "segment.transferDate"
                                            }
                                          }),
                                          _vm._v(
                                            " Indica la fecha y la hora de salida correspondiente a este tramo específico del viaje. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field:
                                    "returnSegments[" +
                                    index +
                                    "].transferOrigin",
                                  label: "Origen"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "returnSegments[" +
                                                index +
                                                "].transferOrigin",
                                              placeholder: "Ingrese origen",
                                              "data-vv-as": "origen",
                                              "data-cy":
                                                "return-transfer-origin-" +
                                                index,
                                              state: invalid
                                            },
                                            model: {
                                              value: segment.transferOrigin,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  segment,
                                                  "transferOrigin",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "segment.transferOrigin"
                                            }
                                          }),
                                          _vm._v(
                                            " Ingresa el lugar de inicio de este tramo específico del viaje. Puede ser una ciudad, aeropuerto, terminal, dirección, etc. según corresponda. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-6" },
                            [
                              _c("validate-field", {
                                attrs: {
                                  field:
                                    "returnSegments[" +
                                    index +
                                    "].transferDestination",
                                  label: "Destino"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        return [
                                          _c("b-input", {
                                            directives: [
                                              {
                                                name: "validate",
                                                rawName: "v-validate",
                                                value: "required",
                                                expression: "'required'"
                                              }
                                            ],
                                            attrs: {
                                              name:
                                                "returnSegments[" +
                                                index +
                                                "].transferDestination",
                                              placeholder: "Ingrese destino",
                                              "data-vv-as": "destino",
                                              "data-cy":
                                                "return-transfer-destination-" +
                                                index,
                                              state: invalid
                                            },
                                            model: {
                                              value:
                                                segment.transferDestination,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  segment,
                                                  "transferDestination",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "segment.transferDestination"
                                            }
                                          }),
                                          _vm._v(
                                            " Ingresa el lugar de destino de este tramo específico del viaje. Puede ser una ciudad, aeropuerto, terminal, dirección, etc. según corresponda. "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "b-form-group",
                                { staticClass: "mt-0 mt-md-8" },
                                [
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for: "returnRefundAppliesTrue-" + index
                                      }
                                    },
                                    [_vm._v("¿Aplica reembolso?")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex type-resend" },
                                    [
                                      _c(
                                        "b-form-radio",
                                        {
                                          attrs: {
                                            id:
                                              "returnRefundAppliesTrue-" +
                                              index,
                                            value: true,
                                            name:
                                              "returnRefundApplies-" + index,
                                            "data-cy":
                                              "return-refund-applies-" + index,
                                            "data-vv-as": "¿Aplica reembolso?"
                                          },
                                          on: {
                                            input: function($event) {
                                              segment.justification = ""
                                            }
                                          },
                                          model: {
                                            value: segment.refundApplies,
                                            callback: function($$v) {
                                              _vm.$set(
                                                segment,
                                                "refundApplies",
                                                $$v
                                              )
                                            },
                                            expression: "segment.refundApplies"
                                          }
                                        },
                                        [_vm._v(" Si ")]
                                      ),
                                      _c(
                                        "b-form-radio",
                                        {
                                          staticClass: "ml-4",
                                          attrs: {
                                            value: false,
                                            name:
                                              "returnRefundApplies-" + index,
                                            "data-cy":
                                              "return-refund-applies-" + index,
                                            "data-vv-as": "¿Aplica reembolso?"
                                          },
                                          on: {
                                            input: function($event) {
                                              segment.justification = ""
                                            }
                                          },
                                          model: {
                                            value: segment.refundApplies,
                                            callback: function($$v) {
                                              _vm.$set(
                                                segment,
                                                "refundApplies",
                                                $$v
                                              )
                                            },
                                            expression: "segment.refundApplies"
                                          }
                                        },
                                        [_vm._v(" No ")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    " Indica si los gastos de este tramo específico del viaje deberán ser reembolsados "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          !segment.refundApplies
                            ? _c(
                                "div",
                                { staticClass: "col-12" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field:
                                        "returnSegments[" +
                                        index +
                                        "].justification",
                                      label: "Justificación"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-form-textarea", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required: !segment.refundApplies
                                                    },
                                                    expression:
                                                      "{ required: !segment.refundApplies }"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "returnSegments[" +
                                                    index +
                                                    "].justification",
                                                  "data-vv-as": "justificación",
                                                  "data-cy":
                                                    "return-justification-" +
                                                    index,
                                                  state: invalid,
                                                  maxlength: 2000,
                                                  placeholder: "Justificación",
                                                  rows: "3",
                                                  "max-rows": "8"
                                                },
                                                model: {
                                                  value: segment.justification,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      segment,
                                                      "justification",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "segment.justification"
                                                }
                                              }),
                                              _c(
                                                "small",
                                                {
                                                  staticClass:
                                                    "form-text text-muted text-right"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        segment.justification
                                                          ? segment
                                                              .justification
                                                              .length
                                                          : 0
                                                      ) +
                                                      " / 2000 "
                                                  )
                                                ]
                                              ),
                                              _vm._v(
                                                " Si selecciona NO, debe justificar su respuesta e indicar la fuente de financiamiento. "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 d-flex justify-content-end gap-2 mt-2"
                            },
                            [
                              index > 0
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-danger",
                                        "data-cy": "return-remove-" + index
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeReturnSegment(index)
                                        }
                                      }
                                    },
                                    [_vm._v(" Quitar tramo ")]
                                  )
                                : _vm._e(),
                              index === _vm.formData.returnSegments.length - 1
                                ? _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-primary",
                                        "data-cy": "return-add"
                                      },
                                      on: { click: _vm.addReturnSegment }
                                    },
                                    [_vm._v(" + Agregar tramo de regreso ")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  }),
                  _vm._m(8),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mt-0 mt-md-8" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "m-0",
                              attrs: {
                                name: "travelMinorTo7days",
                                "data-cy": "travel-minor-to-7days",
                                "data-vv-as":
                                  "La solicitud del viaje es menor a 7 días de anticipación"
                              },
                              model: {
                                value: _vm.formData.travelMinorTo7days,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "travelMinorTo7days",
                                    $$v
                                  )
                                },
                                expression: "formData.travelMinorTo7days"
                              }
                            },
                            [
                              _vm._v(
                                " La solicitud del viaje es menor a 7 días de anticipación "
                              )
                            ]
                          ),
                          _vm._v(
                            " Marca “Sí” si la fecha de inicio del viaje está a menos de 7 días desde hoy. "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.formData.travelMinorTo7days
                    ? _c("div", { staticClass: "col-12" }, [
                        _c("h6", { staticClass: "text-primary" }, [
                          _vm._v(" Declaración de responsabilidad ")
                        ]),
                        _c("p", [
                          _vm._v(
                            " La compra de pasaje y su fecha de ida es menor a lo exigido por DIPRES en cuanto buen uso de recursos públicos, en el que se indica que la fecha de compra debe ser como mínimo 7 días previo al vuelo, para continuar con la compra, debe ingresar justificación. "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm.formData.travelMinorTo7days
                    ? _c("div", { staticClass: "col-12" }, [
                        _c("h6", { staticClass: "text-primary" }, [
                          _vm._v(" Justificación ")
                        ]),
                        _c("p", [
                          _vm._v(
                            " Selecciona el motivo que corresponde e indica brevemente la razón específica en el campo “Especificar”. "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm.formData.travelMinorTo7days
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("validate-field", {
                            attrs: {
                              field: "shortTravelJustificationMotive",
                              label: "Motivo"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var invalid = ref.invalid
                                    return [
                                      _c("select-options", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required:
                                                _vm.formData.travelMinorTo7days
                                            },
                                            expression:
                                              "{required: formData.travelMinorTo7days}"
                                          }
                                        ],
                                        attrs: {
                                          name:
                                            "shortTravelJustificationMotive",
                                          "alphabetical-sort": true,
                                          "options-group": "motivo-viaje-menor",
                                          "data-vv-as": "motivo",
                                          "data-cy":
                                            "short-travel-justification-motive",
                                          invalid: invalid
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .shortTravelJustificationMotive,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "shortTravelJustificationMotive",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.shortTravelJustificationMotive"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2393511326
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.travelMinorTo7days
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("validate-field", {
                            attrs: {
                              field: "shortTravelJustification",
                              label: "Especificar"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var invalid = ref.invalid
                                    return [
                                      _c("b-form-textarea", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required:
                                                _vm.formData.travelMinorTo7days
                                            },
                                            expression:
                                              "{required: formData.travelMinorTo7days}"
                                          }
                                        ],
                                        attrs: {
                                          name: "shortTravelJustification",
                                          "data-vv-as": "especificar",
                                          "data-cy":
                                            "short-travel-justification",
                                          state: invalid,
                                          maxlength: 2000,
                                          placeholder: "Especificar",
                                          rows: "3",
                                          "max-rows": "8"
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .shortTravelJustification,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "shortTravelJustification",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.shortTravelJustification"
                                        }
                                      }),
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "form-text text-muted text-right"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formData
                                                  .shortTravelJustification
                                                  ? _vm.formData
                                                      .shortTravelJustification
                                                      .length
                                                  : 0
                                              ) +
                                              " / 2000 "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              490281510
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._m(9),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("validate-field", {
                        attrs: {
                          field: "serviceCostCenter",
                          label: "Centro de Costos"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var invalid = ref.invalid
                              return [
                                _c("select-options", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "serviceCostCenter",
                                    "alphabetical-sort": true,
                                    "options-group":
                                      "fisabs-service-cost-center",
                                    "data-vv-as": "centro de costos",
                                    "data-cy": "service-cost-center",
                                    invalid: invalid
                                  },
                                  model: {
                                    value: _vm.formData.serviceCostCenter,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "serviceCostCenter",
                                        $$v
                                      )
                                    },
                                    expression: "formData.serviceCostCenter"
                                  }
                                }),
                                _c("span", [
                                  _vm._v(
                                    " Selecciona el centro de costo que financiará el cometido. "
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c("validate-field", {
                        attrs: {
                          field: "serviceFundingSource",
                          label: "Fuente de financiamiento"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var invalid = ref.invalid
                              return [
                                _c("select-options", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    }
                                  ],
                                  attrs: {
                                    name: "serviceFundingSource",
                                    "options-group":
                                      "fisabs-service-funding-source",
                                    "data-vv-as": "fuente de financiamiento",
                                    "data-cy": "service-funding-source",
                                    invalid: invalid
                                  },
                                  model: {
                                    value: _vm.formData.serviceFundingSource,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "serviceFundingSource",
                                        $$v
                                      )
                                    },
                                    expression: "formData.serviceFundingSource"
                                  }
                                }),
                                _c("span", [
                                  _vm._v(
                                    " Indica la fuente que cubrirá los gastos. "
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mt-0 mt-md-8" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "m-0",
                              attrs: {
                                name: "isUryRed",
                                "data-cy": "is-ury-red",
                                "data-vv-as": "Es proyecto URY-RED"
                              },
                              on: { change: _vm.clearUryProjectData },
                              model: {
                                value: _vm.formData.isUryRed,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "isUryRed", $$v)
                                },
                                expression: "formData.isUryRed"
                              }
                            },
                            [_vm._v(" Es proyecto URY-RED ")]
                          ),
                          _vm._v(
                            " Selecciona “Sí” solo si el cometido está asociado a un proyecto URY-RED. "
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.formData.isUryRed
                    ? _c("div", { staticClass: "col-12" }, [
                        _c("h4", [
                          _vm._v(
                            " Detalles técnicos (solo para proyectos URY-RED). "
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm.formData.isUryRed
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("validate-field", {
                            attrs: {
                              field: "serviceInPurchasePlan",
                              label:
                                "¿Está en Plan de Gastos? (Solo para Proyectos)"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var invalid = ref.invalid
                                    return [
                                      _c("select-options", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          name: "serviceInPurchasePlan",
                                          "data-vv-as":
                                            "indicar si está en plan de gastos",
                                          "data-cy": "service-in-purchase-plan",
                                          invalid: invalid,
                                          options: _vm.options.yesOrNo,
                                          mapper: function(opt) {
                                            return { value: opt, label: opt }
                                          }
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.formData.servicePurchasePlanJustification =
                                              ""
                                          }
                                        },
                                        model: {
                                          value:
                                            _vm.formData.serviceInPurchasePlan,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "serviceInPurchasePlan",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.serviceInPurchasePlan"
                                        }
                                      }),
                                      _vm._v(
                                        " Indica si el cometido aparece en el Plan de Gastos aprobado del proyecto. "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              728284755
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.serviceInPurchasePlan === "No" &&
                  _vm.formData.isUryRed
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("validate-field", {
                            attrs: {
                              field: "servicePurchasePlanJustification",
                              label:
                                "Justificación en caso de no estar en plan de gastos"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var invalid = ref.invalid
                                    return [
                                      _c("b-form-textarea", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: {
                                              required:
                                                _vm.formData
                                                  .serviceInPurchasePlan ===
                                                "No"
                                            },
                                            expression:
                                              "{required: formData.serviceInPurchasePlan === 'No'}"
                                          }
                                        ],
                                        attrs: {
                                          maxlength: 2000,
                                          rows: "3",
                                          "max-rows": "8",
                                          name:
                                            "servicePurchasePlanJustification",
                                          placeholder:
                                            "Ingrese la justificación",
                                          "data-vv-as":
                                            "justificación en caso de no estar en plan de gastos",
                                          "data-cy":
                                            "service-purchase-plan-justification",
                                          state: invalid
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .servicePurchasePlanJustification,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "servicePurchasePlanJustification",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.servicePurchasePlanJustification"
                                        }
                                      }),
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "form-text text-muted text-right"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formData
                                                  .servicePurchasePlanJustification
                                                  ? _vm.formData
                                                      .servicePurchasePlanJustification
                                                      .length
                                                  : 0
                                              ) +
                                              " / 2000 "
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        " Explica por qué esta actividad debe incorporarse ahora al Plan de Gastos y por qué no fue incluida originalmente. "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1143980091
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.isUryRed
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c(
                            "validate-field",
                            {
                              attrs: { field: "serviceGlosa", label: "Glosa" }
                            },
                            [
                              _c("b-input", {
                                attrs: {
                                  name: "serviceGlosa",
                                  placeholder: "Ingrese la glosa",
                                  "data-cy": "service-glosa"
                                },
                                model: {
                                  value: _vm.formData.serviceGlosa,
                                  callback: function($$v) {
                                    _vm.$set(_vm.formData, "serviceGlosa", $$v)
                                  },
                                  expression: "formData.serviceGlosa"
                                }
                              }),
                              _vm._v(
                                " (Nombre del proyecto cuando corresponda). "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.isUryRed
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c(
                            "validate-field",
                            {
                              attrs: {
                                field: "serviceExpenseClassification",
                                label: "Clasificación del gasto"
                              }
                            },
                            [
                              _c("select-options", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: _vm.formData.isUryRed },
                                    expression: "{required: formData.isUryRed}"
                                  }
                                ],
                                attrs: {
                                  name: "serviceExpenseClassification",
                                  "options-group":
                                    "fisabs-service-expense-classification",
                                  "data-cy": "service-expense-classification",
                                  "data-vv-as": "clasificación del gasto",
                                  "alphabetical-sort": true
                                },
                                model: {
                                  value:
                                    _vm.formData.serviceExpenseClassification,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "serviceExpenseClassification",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "formData.serviceExpenseClassification"
                                }
                              }),
                              _vm._v(
                                " (Asociado a movilización y mantención). "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.isUryRed
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("validate-field", {
                            attrs: {
                              field: "serviceProjectObjective",
                              label: "Objetivo del proyecto"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var invalid = ref.invalid
                                    return [
                                      _c("b-form-textarea", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          maxlength: 2000,
                                          rows: "3",
                                          "max-rows": "8",
                                          invalid: invalid,
                                          name: "serviceProjectObjective",
                                          "data-vv-as": "objetivo del proyecto",
                                          placeholder:
                                            "Ingrese el objetivo del proyecto",
                                          "data-cy": "service-project-objective"
                                        },
                                        model: {
                                          value:
                                            _vm.formData
                                              .serviceProjectObjective,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "serviceProjectObjective",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.serviceProjectObjective"
                                        }
                                      }),
                                      _c(
                                        "small",
                                        {
                                          staticClass:
                                            "form-text text-muted text-right"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formData
                                                  .serviceProjectObjective
                                                  ? _vm.formData
                                                      .serviceProjectObjective
                                                      .length
                                                  : 0
                                              ) +
                                              " / 2000 "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1681362725
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.isUryRed
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("validate-field", {
                            attrs: {
                              field: "serviceResult",
                              label:
                                "Resultado / Hito / Actividad principal / Indicador"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var invalid = ref.invalid
                                    return [
                                      _c("b-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        attrs: {
                                          invalid: invalid,
                                          name: "serviceResult",
                                          "data-vv-as":
                                            "resultado/hito/actividad principal/indicador",
                                          placeholder:
                                            "Ingrese el resultado/hito/actividad principal/indicador",
                                          "data-cy": "service-result"
                                        },
                                        model: {
                                          value: _vm.formData.serviceResult,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "serviceResult",
                                              $$v
                                            )
                                          },
                                          expression: "formData.serviceResult"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              250610868
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.formData.isUryRed
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("validate-field", {
                            attrs: {
                              field: "serviceExpenseCode",
                              label:
                                "Código del gasto en el plan de gastos del proyecto"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var invalid = ref.invalid
                                    return [
                                      _c("b-input", {
                                        attrs: {
                                          name: "serviceExpenseCode",
                                          placeholder:
                                            "Ingrese el código del gasto en el plan de gastos del proyecto",
                                          "data-cy": "service-expense-code"
                                        },
                                        model: {
                                          value:
                                            _vm.formData.serviceExpenseCode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "serviceExpenseCode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formData.serviceExpenseCode"
                                        }
                                      }),
                                      _vm._v(
                                        " (En caso de incurrir en viáticos o movilización, ingresar ambos códigos). "
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3134799775
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._m(10),
                  _c(
                    "div",
                    { staticClass: "col-6" },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mt-0 mt-md-8" },
                        [
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "m-0",
                              attrs: {
                                name: "isFlyingTicketIncluded",
                                "data-cy": "is-flying-ticket-included",
                                "data-vv-as": "Incluye compra de pasaje aéreo"
                              },
                              on: { change: _vm.clearFlyingTicketData },
                              model: {
                                value: _vm.formData.isFlyingTicketIncluded,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formData,
                                    "isFlyingTicketIncluded",
                                    $$v
                                  )
                                },
                                expression: "formData.isFlyingTicketIncluded"
                              }
                            },
                            [_vm._v(" Incluye compra de pasaje aéreo ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.formData.isFlyingTicketIncluded
                    ? _c("div", { staticClass: "col-12" }, [
                        _c("div", { staticClass: "row" }, [
                          _vm._m(11),
                          _vm.formData.isFlyingTicketIncluded
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketBirthDate",
                                      label: "Fecha de nacimiento"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("date-picker", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required:
                                                        _vm.formData
                                                          .isFlyingTicketIncluded
                                                    },
                                                    expression:
                                                      "{ required: formData.isFlyingTicketIncluded}"
                                                  }
                                                ],
                                                attrs: {
                                                  name: "flyingTicketBirthDate",
                                                  placeholder:
                                                    "Seleccione la fecha de nacimiento",
                                                  "data-vv-as":
                                                    "fecha de nacimiento",
                                                  format: "YYYY-MM-DD",
                                                  "value-type": "YYYY-MM-DD",
                                                  "data-cy":
                                                    "flying-ticket-birth-date",
                                                  invalid: invalid
                                                },
                                                on: {
                                                  "formatted-input": function(
                                                    $event
                                                  ) {
                                                    _vm.formData.flyingTicketBirthDate = $event
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketBirthDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketBirthDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketBirthDate"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      4035192154
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.isFlyingTicketIncluded
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketPhone",
                                      label: "Teléfono"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required:
                                                        _vm.formData
                                                          .isFlyingTicketIncluded
                                                    },
                                                    expression:
                                                      "{ required: formData.isFlyingTicketIncluded}"
                                                  }
                                                ],
                                                attrs: {
                                                  name: "flyingTicketPhone",
                                                  placeholder:
                                                    "Ingrese el teléfono",
                                                  "data-vv-as": "teléfono",
                                                  "data-cy":
                                                    "flying-ticket-phone",
                                                  invalid: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketPhone,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketPhone",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketPhone"
                                                }
                                              }),
                                              _vm._v(
                                                " Indica un número válido donde se te pueda contactar. "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3221829458
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.isFlyingTicketIncluded
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketInstitutionalEmail",
                                      label: "Correo Institucional"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required:
                                                        _vm.formData
                                                          .isFlyingTicketIncluded
                                                    },
                                                    expression:
                                                      "{ required: formData.isFlyingTicketIncluded}"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "flyingTicketInstitutionalEmail",
                                                  placeholder:
                                                    "Ingrese el correo institucional",
                                                  "data-vv-as":
                                                    "correo institucional",
                                                  "data-cy":
                                                    "flying-ticket-institutional-email",
                                                  invalid: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketInstitutionalEmail,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketInstitutionalEmail",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketInstitutionalEmail"
                                                }
                                              }),
                                              _vm._v(
                                                " Escribe tu correo institucional vigente. "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3722748618
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.isFlyingTicketIncluded
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketLuggage",
                                      label: "Equipaje"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("select-options", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: {
                                                      required:
                                                        _vm.formData
                                                          .isFlyingTicketIncluded
                                                    },
                                                    expression:
                                                      "{ required: formData.isFlyingTicketIncluded}"
                                                  }
                                                ],
                                                attrs: {
                                                  name: "flyingTicketLuggage",
                                                  "alphabetical-sort": true,
                                                  "options-group":
                                                    "tipos-equipaje",
                                                  "data-vv-as": "equipaje",
                                                  multiple: "",
                                                  "data-cy":
                                                    "flying-ticket-luggage",
                                                  invalid: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketLuggage,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketLuggage",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketLuggage"
                                                }
                                              }),
                                              _vm._v(
                                                " Marca todos los tipos de equipaje que necesitarás para el vuelo. "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2903889734
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.needsJustificationLuggage
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketLuggageJustification",
                                      label: "Justificación"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-form-textarea", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    "flyingTicketLuggageJustification",
                                                  state: invalid,
                                                  maxlength: 2000,
                                                  placeholder: "Justificación",
                                                  "data-vv-as": "justificación",
                                                  "data-cy":
                                                    "flying-ticket-luggage-justification",
                                                  invalid: invalid,
                                                  rows: "3",
                                                  "max-rows": "8"
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketLuggageJustification,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketLuggageJustification",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketLuggageJustification"
                                                }
                                              }),
                                              _vm._v(
                                                " Explica por qué se requiere equipaje adicional, si aplica. "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      3932124606
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._m(12),
                          _vm._m(13),
                          _vm.formData.isFlyingTicketIncluded
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketDestinationDate",
                                      label: "Fecha sugerida"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("date-picker", {
                                                attrs: {
                                                  name:
                                                    "flyingTicketDestinationDate",
                                                  placeholder:
                                                    "Seleccione la fecha sugerida",
                                                  "data-vv-as":
                                                    "fecha sugerida",
                                                  type: "datetime",
                                                  format: "YYYY-MM-DD HH:mm",
                                                  "data-cy":
                                                    "flying-ticket-destination-date",
                                                  disablePastDates: true,
                                                  invalid: invalid
                                                },
                                                on: {
                                                  "formatted-input": function(
                                                    $event
                                                  ) {
                                                    _vm.formData.flyingTicketDestinationDate = $event
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketDestinationDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketDestinationDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketDestinationDate"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      726113467
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.isFlyingTicketIncluded
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketDestinationInfo",
                                      label: "Línea aérea y número de vuelo"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                attrs: {
                                                  name:
                                                    "flyingTicketDestinationInfo",
                                                  placeholder:
                                                    "Línea aérea y número de vuelo",
                                                  "data-vv-as": "origen",
                                                  "data-cy":
                                                    "flying-ticket-destination-info",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketDestinationInfo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketDestinationInfo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketDestinationInfo"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      455991747
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.isFlyingTicketIncluded
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketDestinationComments",
                                      label: "Comentarios opcionales"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                attrs: {
                                                  name:
                                                    "flyingTicketDestinationComments",
                                                  placeholder:
                                                    "Comentarios opcionales",
                                                  "data-vv-as":
                                                    "comentarios opcionales",
                                                  "data-cy":
                                                    "flying-ticket-destination-comments",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketDestinationComments,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketDestinationComments",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketDestinationComments"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2373961788
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._m(14),
                          _vm.formData.isFlyingTicketIncluded
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketReturnDate",
                                      label: "Fecha sugerida "
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("date-picker", {
                                                attrs: {
                                                  name:
                                                    "flyingTicketReturnDate",
                                                  placeholder:
                                                    "Seleccione la fecha sugerida",
                                                  "data-vv-as":
                                                    "fecha sugerida",
                                                  type: "datetime",
                                                  format: "YYYY-MM-DD HH:mm",
                                                  "data-cy":
                                                    "flying-ticket-return-date",
                                                  invalid: invalid,
                                                  disablePastDates: true
                                                },
                                                on: {
                                                  "formatted-input": function(
                                                    $event
                                                  ) {
                                                    _vm.formData.flyingTicketReturnDate = $event
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketReturnDate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketReturnDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketReturnDate"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2982000891
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.isFlyingTicketIncluded
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketReturnInfo",
                                      label: "Línea aérea y número de vuelo"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                attrs: {
                                                  name:
                                                    "flyingTicketReturnInfo",
                                                  placeholder:
                                                    "Línea aérea y número de vuelo",
                                                  "data-vv-as": "origen",
                                                  "data-cy":
                                                    "flying-ticket-return-info",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketReturnInfo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketReturnInfo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketReturnInfo"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1791214645
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.formData.isFlyingTicketIncluded
                            ? _c(
                                "div",
                                { staticClass: "col-6" },
                                [
                                  _c("validate-field", {
                                    attrs: {
                                      field: "flyingTicketReturnComments",
                                      label: "Comentarios opcionales"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c("b-input", {
                                                attrs: {
                                                  name:
                                                    "flyingTicketReturnComments",
                                                  placeholder:
                                                    "Comentarios opcionales",
                                                  "data-vv-as":
                                                    "comentarios opcionales",
                                                  "data-cy":
                                                    "flying-ticket-return-comments",
                                                  state: invalid
                                                },
                                                model: {
                                                  value:
                                                    _vm.formData
                                                      .flyingTicketReturnComments,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.formData,
                                                      "flyingTicketReturnComments",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "formData.flyingTicketReturnComments"
                                                }
                                              })
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      146715370
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    : _vm._e(),
                  _vm._m(15),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("validate-field", {
                        attrs: {
                          field: "additionalInformation",
                          label: "Información adicional"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var invalid = ref.invalid
                              return [
                                _c("b-input", {
                                  attrs: {
                                    name: "additionalInformation",
                                    placeholder: "Información adicional",
                                    "data-vv-as": "información adicional",
                                    "data-cy": "additionalInformation",
                                    state: invalid
                                  },
                                  model: {
                                    value: _vm.formData.additionalInformation,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.formData,
                                        "additionalInformation",
                                        $$v
                                      )
                                    },
                                    expression: "formData.additionalInformation"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c("vs-divider"),
                  _vm._m(16),
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      !_vm.scfAttachmentsSelectors.loading
                        ? _c("dynamic-file-selector", {
                            attrs: {
                              selectors: _vm.scfAttachmentsSelectors.list
                                .slice()
                                .sort(function(a, b) {
                                  return a.order - b.order
                                })
                                .map(function(sel) {
                                  return Object.assign({}, sel, sel.extra, {
                                    index: sel.order
                                  })
                                }),
                              "object-to-evaluate": _vm.formData,
                              files: _vm.dynamicSelectorFiles,
                              "reset-key": _vm.dfsResetKey
                            },
                            on: {
                              "update-files": _vm.updateFiles,
                              valid: function(valid) {
                                _vm.dynamicFileSelectorValid = valid
                              }
                            }
                          })
                        : _c(
                            "div",
                            [
                              _c("b-skeleton", {
                                attrs: { animation: "fade", width: "100%" }
                              }),
                              _c("b-skeleton", {
                                attrs: { animation: "fade", width: "100%" }
                              })
                            ],
                            1
                          )
                    ],
                    1
                  )
                ],
                2
              )
            ]
          ),
          _c("form-buttons", {
            attrs: {
              saving: _vm.saving,
              disabled: _vm.dfsSelectorsLoading,
              back: function() {
                return this$1.$router.back()
              },
              preview: _vm.preview,
              save: function() {
                return _vm.save(false)
              },
              saveDraft: _vm.saveDraft
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("IDENTIFICACIÓN DEL SOLICITANTE")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("INFORMACIÓN SOBRE EL COMETIDO Y LAS ACTIVIDADES")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h6", { staticClass: "text-primary" }, [
        _vm._v(" Periodo del cometido ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h6", { staticClass: "text-primary" }, [
        _vm._v(" Destino del cometido ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h6", { staticClass: "text-primary" }, [
        _vm._v(" Detalle de la actividad ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("INFORMACIÓN DEL TRASLADO")]),
      _c("p", [
        _vm._v(
          " Debes ingresar cada tramo del viaje por separado. Un tramo corresponde a un traslado específico, por ejemplo: taxi al aeropuerto, vuelo, taxi desde el aeropuerto al hotel, y el retorno a tu lugar de origen. Cada uno de esos traslados debe registrarse como un tramo independiente e indicar si aplica o no reembolso. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("TRASLADO DE IDA")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("TRASLADO DE REGRESO")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h6", [
        _vm._v(
          " Justificación por compra de pasajes con menos de 7 días de anticipación "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("ANTECEDENTES PRESUPUESTARIOS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v(" INFORMACIÓN SOBRE LOS PASAJES AÉREOS ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 text-primary" }, [
      _c("h6", [
        _vm._v(" Información del Solicitante para la compra de pasajes aéreos ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h6", [_vm._v(" Fechas Sugeridas para el Vuelo ")]),
      _c("p", [
        _vm._v(
          " Ingresa las fechas y horarios sugeridos para tu vuelo de ida y regreso. Estas fechas deben ser coherentes con el periodo del cometido, que debe ajustarse a la normativa vigente de la Universidad, y con las fechas de la actividad, las cuales deben estar respaldadas por medios de verificación válidos. La emisión final del pasaje dependerá de la disponibilidad y de la normativa vigente. "
        )
      ]),
      _c("p", [
        _vm._v(
          " En caso de existir una diferencia justificada entre las fechas informadas en el cometido y las consignadas en los pasajes aéreos efectivamente comprados, y dicha diferencia implique ajustar el viático correspondiente, la presente solicitud de cometido funcionario deberá ser modificada para que ambas fechas queden debidamente alineadas. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [_c("h4", [_vm._v(" IDA ")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v(" REGRESO ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h6", [_vm._v(" Información adicional relevante ")]),
      _c("p", [
        _vm._v(
          " Utiliza este espacio para ingresar cualquier información extra que consideres relevante para la gestión del cometido y que no esté cubierta en los campos anteriores. Puedes incluir aclaraciones, condiciones especiales, antecedentes complementarios o cualquier detalle que facilite la revisión y aprobación de tu solicitud. Cuando corresponda, es recomendable acompañar medios de verificación que respalden la información ingresada. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Documentos")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }